export var TypeActionGrantRewards;
(function (TypeActionGrantRewards) {
    TypeActionGrantRewards["Received"] = "GrantRewards > Received";
    TypeActionGrantRewards["Collect"] = "GrantRewards > Collect";
})(TypeActionGrantRewards || (TypeActionGrantRewards = {}));
export var actionGrantRewardsReceived = function (rewardsType, rewards) { return ({
    rewards: rewards,
    rewardsType: rewardsType,
    type: TypeActionGrantRewards.Received,
}); };
export var actionGrantRewardsCollect = function () { return ({
    type: TypeActionGrantRewards.Collect,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/grant-rewards/actionGrantRewards.ts
// module id = 216
// module chunks = 3